import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'antd';
import classNames from 'classnames/bind';
import styles from '../index.less';
import DragableBodyRow from '../components/BodyRow';

const cx = classNames.bind(styles);

const defaultProps = {
  onDrop: () => {},
};

const propTypes = {
  columns: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  onDrop: PropTypes.func,
};

class DragSortingTable extends React.Component {
  components = {
    body: {
      row: DragableBodyRow,
    },
  }


  swapColumn = (column, start, newStart) => {
    const columnsCopy = _.cloneDeep(column);
    const dragColumns = columnsCopy.splice(start, 1);
    // Insert dragged card into new positions
    columnsCopy.splice(newStart, 0, dragColumns[0]);
    return columnsCopy;
  }

  moveRow = (dragIndex, hoverIndex) => {
    const { onDrop, data } = this.props;
    if (_.isFunction(onDrop) && _.isArray(data)) {
      const newColumn = this.swapColumn(data, dragIndex, hoverIndex);
      onDrop(newColumn);
    }
  }

  render() {
    const {
      data,
      columns,
    } = this.props;
    return (
      <Table
        className={`draggable-table ${cx('picklist-table')}`}
        columns={_.isArray(columns) ? columns : []}
        dataSource={_.isArray(data) ? data : []}
        components={this.components}
        pagination={false}
        scroll={{ y: 200 }}
        rowKey={record => record.id}
        onRow={(record, index) => ({
          index,
          moveRow: this.moveRow,
        })}
      />
    );
  }
}

DragSortingTable.propTypes = propTypes;
DragSortingTable.defaultProps = defaultProps;

export default DragSortingTable;




// WEBPACK FOOTER //
// ./src/components/ui/DraggableTable/container/index.jsx